import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-page-wrapper b-page-wrapper--gray h-flex h-flex-center" }
const _hoisted_2 = { class: "h-pos-rel" }
const _hoisted_3 = { class: "h-flex h-flex-space-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LogInForm = _resolveComponent("LogInForm")!
  const _component_FwPopup = _resolveComponent("FwPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FwPopup, {
      centered: true,
      isFixed: true,
      "max-width": _ctx.isDesktop() ? "518px" : "calc(100% - 20px)",
      width: "90%",
      popupClass: "b-popup-style--no-shadow",
      allowBackgroundScrolling: true,
      disableClosingOnClickOutside: true,
      popupBackground: "#FAFAFC",
      popupRadius: "20px"
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/login-company" }, {
            default: _withCtx(() => [
              _createVNode(_component_FwIcon, {
                icon: "arrow-left",
                style: {"top":"50px","left":"50px"},
                size: "14",
                class: "h-pos-abs",
                color: "#27dbbd"
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_LogInForm, {
              class: "b-login-base-popup",
              globalServerError: _ctx.globalServerError,
              isRequestSend: _ctx.isRequestSend,
              onSubmitForm: _ctx.doLogin
            }, null, 8, ["globalServerError", "isRequestSend", "onSubmitForm"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["max-width"])
  ]))
}